// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const GuillaumeLemaitrelPR_probabl_ai_skore_966_From_204_12_01_To_2024_12_31 = () => {
  return (
    <>
     <a
        href="https://github.com/glemaitre?tab=overview&from=2024-12-01&to=2024-12-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Feb 1, 2025 to Feb 28, 2025
      </a>
<div>
<a
        href="https://github.com/glemaitre?tab=overview&from=2024-12-01&to=2024-12-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/glemaitre?tab=overview&from=2024-12-01&to=2024-12-31
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
><bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title">Using pickling as much as possible for serialization</bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/probabl-ai/skore/issues/966" target="_blank" rel="noopener noreferrer">
  #966
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/glemaitre" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">glemaitre</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/probabl-ai/skore/issues/966" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Dec 16, 2024</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific PR from the <a href="https://github.com/probabl-ai/skore/issues/966" target="_blank">probabl-ai/skore repository</a>:</p>

    </>
  );
};

export default GuillaumeLemaitrelPR_probabl_ai_skore_966_From_204_12_01_To_2024_12_31;
